module.exports = function() {
  return new Worker("/" + "coffee-transpiler.25bb9059.worker.js");
};